import {
  IAlertViewModalController,
  IT_ALERT_VIEW_MODAL_CONTROLLER,
  MK_ALERT_VIEW_MODAL_MODEL
} from "../_controllers/IAlertViewModalController";
import {AlertViewModalModel} from "../_models/AlertViewModalModel";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {Component, InjectionToken, ViewEncapsulation} from "@angular/core";
import {Options, VideoHandler} from "ngx-quill-upload";
import {AlertViewModalHeaderView} from "../alert-view-modal-header/_views/alert-view-modal-header.view";
import Quill from "quill";
import {AbstractMainModalView} from "../../../views/AbstractMainModalView";
import {AlertData} from "../../../interfaces/domain/alert/AlertData";
import {ModalFooterView} from "../../modal-footer/_views/modal-footer.view";
import { AlertStatus } from "../../../interfaces/domain/alert/AlertStatus";
import {CommonConstants} from "../../../constants/CommonConstants";

Quill.register('modules/videoHandler', VideoHandler);

@Component({
  selector: 'link-alert-view-modal',
  templateUrl: './alert-view-modal.view.html',
  styleUrls: ['./alert-view-modal.view.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlertViewModalView extends AbstractMainModalView<IAlertViewModalController>{

  protected readonly model: AlertViewModalModel;
  quillModules = {
    videoHandler: {
      accepts: ['mp4', 'avi']
    } as Options
  };

  protected readonly AlertStatus = AlertStatus;

  constructor(dialogService: DialogService, dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);

    this.model = this.getController().getModel(MK_ALERT_VIEW_MODAL_MODEL);
  }

  static show(dialogService: DialogService,
              alertData: AlertData,
              controllerToken: InjectionToken<IAlertViewModalController>|null = null) {
    return dialogService.open(AlertViewModalView, {
      data: {
        __controllerToken: controllerToken || IT_ALERT_VIEW_MODAL_CONTROLLER,
        alert: alertData
      },
      templates: {
        header: AlertViewModalHeaderView,
        footer: ModalFooterView,
      },
      width: '60vw',
      breakpoints: CommonConstants.modalBreakpoints,
      closable: true,
      focusOnShow: false,
    });
  }
}
